// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"194":"b8ec0bb4","205":"1097b13e","783":"f804969c","822":"55c93578"}[chunkId] + ".css";
};